import React from "react";
import IberchemLogo from "../../assets/images/Iberchem_logo.png"
import DullbergLogo from "../../assets/images/dullberg_logo.png"
import IffLogo from "../../assets/images/iff_logo.png"

export const Product = () => {
    return (
        <div className="p-4 sm:p-6 md:p-8 lg:p-10">
            <div className="grid gap-4 md:gap-6 bg-[#FAFAFA] rounded-xl py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8">
                <div className="text-center">
                    <p className="text-[#548CA8] text-sm sm:text-base">Product Kami</p>
                    <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold mt-2 max-w-4xl mx-auto leading-tight">
                        Dapatkan Parfum Berkualitas dengan Beragam Pilihan Menarik
                    </h1>
                </div>
                <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-4 md:gap-6 mt-4 md:mt-6">
                    <img 
                        className="w-32 h-20 sm:w-36 sm:h-22 md:w-40 md:h-24 lg:w-44 lg:h-26 bg-white p-4 sm:p-5 md:p-6 rounded-md object-contain shadow-sm hover:shadow-md transition-shadow duration-200" 
                        src={IberchemLogo} 
                        alt="Iberchem Logo" 
                    />
                    <img 
                        className="w-32 h-20 sm:w-36 sm:h-22 md:w-40 md:h-24 lg:w-44 lg:h-26 bg-white p-4 sm:p-5 md:p-6 rounded-md object-contain shadow-sm hover:shadow-md transition-shadow duration-200" 
                        src={DullbergLogo} 
                        alt="Dullberg Logo" 
                    />
                    <img 
                        className="w-32 h-20 sm:w-36 sm:h-22 md:w-40 md:h-24 lg:w-44 lg:h-26 bg-white p-4 sm:p-5 md:p-6 rounded-md object-contain shadow-sm hover:shadow-md transition-shadow duration-200" 
                        src={IffLogo} 
                        alt="IFF Logo" 
                    />
                </div>
            </div>
        </div>
    )
}